// Mock Mode Configuration
import { SupabaseClient } from '@supabase/supabase-js';
import { Database } from './supabase';

export function isMockModeEnabled(): boolean {
  const mockMode = import.meta.env.VITE_MOCK_MODE;
  
  // Strict boolean conversion
  return mockMode === 'true' || mockMode === true;
}

export function getMockProfile(): string {
  // Allow specifying different mock profiles
  return import.meta.env.VITE_MOCK_PROFILE || 'default';
}

export function validateMockModeConfiguration() {
  const mockMode = isMockModeEnabled();
  const mockProfile = getMockProfile();

  console.info(`Mock Mode: ${mockMode ? 'Enabled' : 'Disabled'}`);
  console.info(`Mock Profile: ${mockProfile}`);

  // Optional: Add more sophisticated mock mode setup
  if (mockMode) {
    // Example: Load mock data or set up mock services
    setupMockServices(mockProfile);
  }
}

function setupMockServices(profile: string) {
  // Placeholder for mock service setup
  // This could involve:
  // - Mocking API calls
  // - Loading specific mock data based on profile
  // - Setting up mock authentication
  switch (profile) {
    case 'minimal':
      // Minimal mock data
      break;
    case 'comprehensive':
      // Full mock data set
      break;
    default:
      // Default mock configuration
      break;
  }
}

// Create a mock Supabase client for testing
export const mockSupabaseClient: SupabaseClient<Database> = {
  auth: {
    signUp: async () => ({ data: { user: null }, error: null }),
    signIn: async () => ({ data: { user: null }, error: null }),
    signOut: async () => ({ error: null }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
  },
  from: () => ({
    select: () => ({ data: [], error: null }),
    insert: () => ({ data: [], error: null }),
    update: () => ({ data: [], error: null }),
    delete: () => ({ data: [], error: null }),
  }),
  rpc: () => ({ data: [], error: null })
} as unknown as SupabaseClient<Database>;